import { FC } from 'react';
import { RefreshCw } from 'lucide-react';

import { Button } from '@new/common/ui/Button/Button';

const EYEBROW = 'Degree planner';
const TITLE = 'Build a plan that works for you';
const DESCRIPTION =
  'We applied your transfer credits toward your degree. Complete the remaining courses and choose the electives that best fit your goals below.';
const REGENERATE_LABEL = 'Regenerate plans';

interface PlanReviewHeaderProps {
  regenerateDisabled: boolean;
  onRegenerate: () => void;
}

export const PlanReviewHeader: FC<PlanReviewHeaderProps> = ({
  regenerateDisabled,
  onRegenerate,
}) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div className="flex flex-col gap-1">
      <span className="uppercase [font-size:var(--fs-l5)]! font-semibold tracking-wide text-(--neutral-black-NB500)">
        {EYEBROW}
      </span>
      <h1 className="m-0! [font-size:var(--fs-h3)]! text-(--neutral-black-NB900)!">{TITLE}</h1>
      <p className="m-0! [font-size:var(--fs-b4)]! text-(--neutral-black-NB700)!">{DESCRIPTION}</p>
    </div>
    <Button
      variant="outline"
      className="w-full shrink-0 sm:w-auto"
      leftIcon={<RefreshCw className="size-4" />}
      text={REGENERATE_LABEL}
      disabled={regenerateDisabled}
      onClick={onRegenerate}
    />
  </div>
);
